<template>
  <v-app id="backlane-maintenance">
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      width="300px"
      class="grey darken-2"
    >
      <!--  -->
      <v-layout class="grey" align-content-space-around column>
        <v-card class="grey darken-2" >
          <v-card-text>
            <v-layout align-center column>
              <div id="searchDiv"></div>
              <!-- <div class="addrSelectTextSmall">
                {{ $hasData(dataObjects[0]) ? 'Selected Address: ' + (dataSources.property.data.STREET_ADDRESS != '' ? dataSources.property.data.STREET_ADDRESS : 'NO ADDRESS ASSIGNED') : 'Please search or select an address' }}
              </div> -->
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="grey lighten-1" min-height="300px">
          <v-card-title class="grey lighten-2">
            RESULTS
          </v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item v-for="(item, index) in displayAttribs" :key="index">
                <v-list-item-content>
                  <v-list-item-title>{{item.name}}</v-list-item-title>
                  {{ item.value }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-alert 
              v-if="firstVisit"
              :value="alerts.laneAlert"
              dense
              outlined
              border="left"
              color="grey darken-3"
              transition="scale-transition"
              dismissible
              class="text-body-2"
            >
              Click lane location or work activity headers to show or hide additional details
            </v-alert>
            <v-list dense>
              <v-list-group
                v-for="(lane, laneIndex) in lanes"
                :key="'lane'+laneIndex"
                v-model="lane.active"
                :class="lane.active ? 'white' : 'grey lighten-3'"
                @click="laneClick(lane)"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="lane.Location"></v-list-item-title>
                    <v-list-item-subtitle v-text="'ID: ' + lane.OBJECTID"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <v-divider></v-divider>
                <v-list-item v-for="(laneProp, propIndex) in laneProps" :key="'laneProp'+propIndex">
                  <v-list-item-content>
                    <v-list-item-title>{{laneProp.label}}</v-list-item-title>
                    <v-list-item-subtitle>{{formatLaneValues(lane[laneProp.field])}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if='lane.work.length === 0'>
                  <v-list-item-content class="text-caption font-weight-medium">
                    No work found
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-else>
                  <v-list>
                    <v-list-group
                      v-for="(work, workIndex) in lane.work"
                      :key="'work'+workIndex"
                      :class="work.active ? 'white' : 'grey lighten-4'"
                      v-model="work.active"
                    >
                      <template v-slot:activator>
                        <v-list-item-content>
                          <!-- <v-list-item-title v-text="work.Description"></v-list-item-title> -->
                          <v-list-item-title v-text="getWorkDate(work)"></v-list-item-title>
                        </v-list-item-content>
                      </template>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content>
                          <!-- <v-list-item-title>Date Completed</v-list-item-title> -->
                          <v-list-item-title>Work Done</v-list-item-title>
                          <!-- <v-list-item-subtitle>{{ getWorkDate(work) }}</v-list-item-subtitle> -->
                          <v-list-item-subtitle>{{ work.Description }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-group>
                  </v-list>
                </v-list-item>
              </v-list-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-navigation-drawer>

    <v-app-bar clipped-left app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Backlane Maintenance</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-btn class="mr-md-2" color="primary" fab small title="Give Feedback" @click="feedback.show = true"><v-icon>mdi-bullhorn</v-icon></v-btn>
      <v-btn color="primary" fab small title="Open Help" @click="alerts.helpDialog.show = true"><v-icon>mdi-help</v-icon></v-btn>
    </v-app-bar>

    <v-main>
      <!--  -->
      <arcgis-map
        :configReady="mapConfigReady"
        :mapConfig="mapConf"
        :checkedLayers="checkedLayers"
        :selectedFeature="selectedFeature"
        :listLane="listLane"
        :selectionData="selectionData"
        :resetView="resetView"
        :domains="{}"
        :searchValue="searchValue"
        :smallLayout="false"
        :ieEleven="false"
        :facilityIds="workActivity"
        @search-complete="searchComplete"
        @list-highlight-complete="listHighlightComplete"
        @search-clear="clearData"
      >
      </arcgis-map>
    </v-main>

    <v-snackbar
      v-model="alerts.helpSnackbar.show"
      timeout="30000"
    >
      <!-- <v-container text-center> -->
        <p><v-btn color="info" @click="alerts.helpSnackbar.videoClick()">Watch How-To Video</v-btn></p>
        <p><v-btn color="info" @click="alerts.helpSnackbar.helpClick()">Open Help Dialog</v-btn></p>
      <!-- </v-container> -->
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="alerts.helpSnackbar.dismiss()"
        >
          Dismiss
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog width="720" v-model="feedback.show">
      <v-card>
        <v-card-title class='grey lighten-2'>
          Backlane Maintenance - Feedback
          <v-spacer></v-spacer>
          <v-btn icon title="Close Feedback" @click="feedbackClose" >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-alert class="mt-md-2" :value="feedback.submitted && feedback.success" type="info" >
            Successfully submitted feedback. Thank you!
          </v-alert>
          <v-alert class="mt-md-2" :value="feedback.submitted && !feedback.success" type="error" >
            Error submitting feedback.
          </v-alert>
          <v-form>
            <v-radio-group v-model="feedback.data.rate" label="Please Rate Your Experience" >
              <v-radio label="5 - Great" value="5" />
              <v-radio label="4 - Good" value="4" />
              <v-radio label="3 - Satisfactory" value="3" />
              <v-radio label="2 - Fair" value="2" />
              <v-radio label="1 - Poor" value="1" />
            </v-radio-group>
            <v-textarea color="accent" v-model="feedback.data.comments" rows="10" label="Please Provide Your Detailed Feedback"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions class="grey lighten-2">
          <v-spacer></v-spacer>
          <v-btn @click="sendFeedback">Submit</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="720" v-model="alerts.helpDialog.show">
      <v-card>
        <v-card-title class='grey lighten-3'>
          Backlane Maintenance - Help
          <v-spacer></v-spacer>
          <v-btn icon title="Close Help" @click="alerts.helpDialog.show = false" >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-tabs v-model="alerts.helpDialog.activeTab" slider-color="info">
            <v-tab >Help</v-tab>
            <v-tab >Video</v-tab>
            <v-tab-item>
              <v-card-text>
                <div>
                  <h3>Finding an Address</h3>
                  <p>
                    Enter an address in the search box in the 
                    top left hand corner of the map and select an address from
                    the dropdown menu. You can also press enter or click the search button
                    if you don't see the address you're looking for in the dropdown, though
                    a match may not be found.
                  </p>
                  <h3>Understanding the Results</h3>
                  <p>
                    Once an address is selected or a valid search is done, the map
                    will zoom to the property parcel for that address and any nearby
                    lanes will be highlighted on the map. Underneath the search box
                    some basic details about the address will be displayed, along with
                    a list of any nearby lanes. Details for the closest lane will be
                    displayed with any other nearby lane details minimized. To show the
                    details for another lane click anywhere in the box containing the lane
                    location and id.
                  </p>
                  <p>
                    The details for a lane may contain a list of lane maintenance
                    done during the current calendar year. Similar to the list of lanes the
                    description of the most recent maintenance will displayed and any other
                    maintenance events will be minimized. To show the details for another
                    maintenance events click anywhere in the box containing the date of the
                    maintenance event.
                  </p>
                  <h3>Using the Map</h3>
                  <p>
                    A useful feature of the map that can be checked without searching for an
                    address is seeing which lanes have had maintenance done in the current
                    calendar year. Any such lanes will be indicated on the map and the map
                    legend in the lower right corner will show the relevant lane symbol.
                    <br />
                    <img style='border: 1px black solid' width='300px' src='help_images/map_legend.jpg' />
                  </p>
                  <p>
                    It is also possible to select one or more lanes by clicking on a lane
                    displayed on the map. When a lane has been selected it will be highlighted
                    and the lane details, along with any associated maintenance, will be displayed
                    in the sidebar.
                  </p>
                </div>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <div>
                  <p>
                    <iframe width="640" height="360" src="https://www.youtube.com/embed/4stgiyngB3M" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    <!-- <iframe width="640" height="360" src="https://web.microsoftstream.com/embed/video/f78006c6-4bf6-42fe-adb0-8e8a3a948b48?autoplay=false&amp;showinfo=true" allowfullscreen style="border:none;"></iframe> -->
                  </p>
                </div>
              </v-card-text>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<script>
  import axios from 'axios'
  import ArcgisMap from './components/ArcgisMap.vue'

  export default {
    components: { ArcgisMap },
    data () {
      return {
        drawer: null,
        resetView: false,
        searchValue: "",
        selectedFeature: null,
        listLane: null,
        selectionData: {},
        laneIds: {},
        checkedLayers: ["backlaneLayer", "parcelLayer"],
        mapConfigReady: false,
        firstVisit: true,
        feedback: {
          show: false,
          submitted: false,
          success: false,
          data: {
            rate: -1,
            comments: "",
            target: "BacklaneMaintenance",
            reqType: "Feedback",
            reqUrl: "https://gisapp.brandon.ca/webmaps/BacklaneMaintenance/",
            browserInfo: "Generic browser"
          }
        },
        feedbackURL: 'https://prod-22.canadacentral.logic.azure.com:443/workflows/6e3582794c774966ba9d8ef9b25a18a3/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=YadcaM4etwh11SAMI-VX7fXMGcvcqp-qS_wYOI1seb4',
        alerts: {
          laneAlert: false,
          helpSnackbar: {
            show: false,
            dismissed: false,
            dismiss: () => {
              this.alerts.helpSnackbar.show = false;
              this.alerts.helpSnackbar.dismissed = true;
            },
            helpClick: () => {
              this.alerts.helpDialog.show = true;
              this.alerts.helpSnackbar.dismiss();
            },
            videoClick: () => {
              // window.open('https://stream.microsoft.com/', '_blank');
              this.alerts.helpDialog.activeTab = 1;
              this.alerts.helpSnackbar.helpClick();
            }
          },
          helpDialog: {
            show: false,
            activeTab: 0
          }
        },
        mapConf: {},
        displayAttribs: [],
        lanes: [],
        workActivity: [],
        maxActivities: 10,
        earliestWorkDate: "2021-01-01",
        laneProps: [
          { label: "Function", field: "FUNCTIONAL"},
          { label: "Surface", field: "SURFACE"},
          { label: "Type", field: "LANETYPE"}
        ],
        laneValues: {
          "BACKLANE": "Back Lane"
        },
        workProps: [
          { label: "Work Type", field: "Description" },
          { label: "Start Date", field: "ActualStart" },
          { label: "Finish Date", field: "ActualFinish" }
        ],
        attribLookup: {
          "BrandonGIS.SDE.ownership.Location": "Address",
          "BrandonGIS.SDE.ownership.BROLL": "Roll Number",
        }
      }
    },
    computed: {
      showSnackbar: function() {
        return this.firstVisit && !this.alerts.helpSnackbar.dismissed;
      }
    },
    methods: {
      async searchComplete(attributes)
      {
        // console.log(attributes);
        this.displayAttribs = [];
        for (let attrib in attributes) {
          if (this.attribLookup[attrib])
            this.displayAttribs.push({ name: this.attribLookup[attrib], value: attributes[attrib] });
        } // for..in
        this.lanes = [];
        this.laneIds = {};
        if (attributes.related) {
          for (let i = 0; i < attributes.related.length; i++) {
            await this.doAssetQuery(attributes.related[i]);
          } // for
        } // if
        else if (attributes.OBJECTID)
          await this.doAssetQuery(attributes);

        if (this.lanes.length > 0) {
          this.laneClick(this.lanes[0]);
          this.alerts.laneAlert = this.firstVisit;
        } // if
        
        this.alerts.helpSnackbar.show = this.showSnackbar;
      }, //searchComplete
      async doAssetQuery({ Location, SURFACE, LANETYPE, FUNCTIONAL, OBJECTID }) {
        let laneWork = [];
        let { data } = await axios.get(`https://gisapp.brandon.ca/webservices/EnquiryFormBackend/api_proxy.aspx?OBJECTID=${OBJECTID}`);
        // console.log(data);

        if (!data.error) {
          laneWork = data["Work Items"].filter( (element) => {
            const workDate = this.getWorkDate(element);
            if (element.Description.search(/backlane|gravel|calcium/i) >= 0 && workDate != "N/A" && workDate >= this.earliestWorkDate) {
              element.active = false;
              return true;
            } // if
            return false;
          });
          if (laneWork.length > 0) {
            laneWork = laneWork.slice(0, this.maxActivities);
            laneWork[0].active = true;
          } // if
        } // if

        if (!this.laneIds[OBJECTID]) {
          // Should JURISDICITON property be added too???
          this.lanes.push({ active: false, Location: Location, SURFACE: SURFACE, LANETYPE: LANETYPE, FUNCTIONAL: FUNCTIONAL, OBJECTID: OBJECTID, work: laneWork });
          this.laneIds[OBJECTID] = true;
        } // if
      }, // doAssetQuery
      async getMapConfig() {
        let { data } = await axios.get(`config/arcgis-map.json`);
        this.mapConf = data;
        if (this.mapConf.basemap) this.mapConfigReady = true;
      }, // getMapConfig
      async getWorkDataset() {
        let { data } = await axios.get(`${this.mapConf.opendataService.url}?format=json&limit=1000&dataset=cw_pavement_workactivity&columns=ENTITYUID`);
        this.workActivity = data;
      }, // getWorkDataset
      laneClick(lane) {
        this.listLane = Object.assign({}, lane);
      },
      listHighlightComplete(selectedLane) {
        if (selectedLane.active === false)
          this.lanes.forEach( lane => {
            if (lane.OBJECTID === selectedLane.OBJECTID)  
              lane.active = true;
          });
      },
      formatLaneValues(value) {
        // Check laneValues for hard-coded format values
        if (this.laneValues[value])
          return this.laneValues[value];
        
        let newVal = "";
        let firstSpace = true;
        value.split(' ').forEach( spaceSplitVal => {
          // let firstDash = true;
          // spaceSplitVal.split('-').forEach( dashSplitVal => {
          //   if (!firstDash)
          //     newVal += "-";
          //   else
          //     firstDash = false;

          //   newVal += dashSplitVal.substring(0,1).toUpperCase() + dashSplitVal.substring(1).toLowerCase();
          // });
          if (!firstSpace)
            newVal += " ";
          else
            firstSpace = false;

          newVal += spaceSplitVal.substring(0,1).toUpperCase() + spaceSplitVal.substring(1).toLowerCase();
        });

        return newVal;
      }, // formatLaneValues
      getWorkDate(work) {
        let date = work.ActualFinish ? work.ActualFinish : work.ActualStart;
        return date ? date.split("T")[0] : 'N/A';
      },
      clearData() {
        this.displayAttribs = [];
        this.lanes = [];
        this.workActivity = [];
        // this.alerts.laneAlert = false;
      }, // clearData
      async sendFeedback() {
        let sendData = { userComment: {} };
        Object.assign(sendData.userComment, this.feedback.data);
        sendData.userComment.comments = encodeURIComponent(sendData.userComment.comments);
        sendData.userComment.rate = encodeURIComponent(sendData.userComment.rate);

        let response = await axios.post(this.feedbackURL, JSON.stringify(sendData), {
          headers: {'Content-Type': 'application/json; charset=utf-8'}
        });

        this.feedback.submitted = true;

        if (response.status === 200) {
          this.feedback.success = true;
          this.feedback.data.comments = "";
          this.feedback.data.rate = -1;
        } // if
        else {
          this.feedback.success = false;
        } // else
      }, // sendFeedback
      feedbackClose() {
        this.feedback.show = false;
        this.feedback.submitted = false;
        this.feedback.success = false;
      }
    },
    async mounted () {
      const visited = window.localStorage.getItem("visited");
      if (visited)
        this.firstVisit = false;
      else
        window.localStorage.setItem("visited", true);
      await this.getMapConfig();
      await this.getWorkDataset();
    } // mounted
  }
</script>
<style scoped>
  .regTitle {
    display: inline-block;
    padding-left: 12px;
  }
  .smallTitle {
    display: block;
    padding-left: 46px;
  }
  .addrSelectText {
    padding-top: 9px;
    text-align: center;
  }
  .addrSelectTextSmall {
    padding-top: 9px;
  }
  .zeroPad {
    padding: 0px;
  }
  .dialogHeight {
    height: 585px;
  }
  .detailsContainer {
    padding: 1px;
  }
</style>